import { render, staticRenderFns } from "./show-tip.vue?vue&type=template&id=6a1111ba&"
import script from "./show-tip.vue?vue&type=script&lang=js&"
export * from "./show-tip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports